import { FC, ReactNode } from 'react';

import Flex from 'app/components/v2/components/Flex/index';

import { SemanticColorKey } from '../../theme/colors';
import Button, { ButtonProps } from '../Button';
import Heading5 from '../Text/Heading5';

// Local Typings
type BannerColor = 'error' | 'primary' | 'success' | 'warning';
interface BannerButtonProps {
  onClick: ButtonProps['onClick'];
  title: string;
}
export interface DialogBannerProps {
  bannerColor: BannerColor;
  bannerText: ReactNode;
  buttonProps?: {
    leftButtonProps?: BannerButtonProps;
    rightButtonProps: BannerButtonProps;
  };
}

// Local Variables
const getBannerColor = (bannerColor: BannerColor): SemanticColorKey => {
  switch (bannerColor) {
    case 'error':
      return 'notification_danger_background';
    case 'primary':
      return 'notification_info_background';
    case 'success':
      return 'notification_success_background';
    case 'warning':
      return 'notification_warning_background';
  }
};

// Component Definition
const DialogBanner: FC<DialogBannerProps> = ({
  bannerColor = 'primary',
  bannerText,
  buttonProps,
}) => (
  <Flex
    backgroundColor={getBannerColor(bannerColor)}
    className="dialog_dialog-banner"
    justifyContent="space-between"
    left={0}
    paddingX={6}
    paddingY={3}
    position="absolute"
    right={0}
    top={0}
    zIndex={3}
  >
    <Heading5
      lineHeight="initial"
    >
      {bannerText}
    </Heading5>

    {buttonProps && (
      <Flex gap={1}>
        {buttonProps.leftButtonProps && (
          <Button
            hierarchy="tertiary"
            onClick={buttonProps.leftButtonProps.onClick}

          >
            {buttonProps.leftButtonProps.title}
          </Button>
        )}

        <Button
          hierarchy="secondary"
          onClick={buttonProps.rightButtonProps.onClick}
        >
          {buttonProps.rightButtonProps.title}
        </Button>
      </Flex>
    )}
  </Flex>
);

export default DialogBanner;
